// Module
var code = "<ng-include ng-if=\"!viewConfig.templateUrl\" src=\"'common/listSelectManagerAndRows.tpl.html'\"></ng-include>\n<ng-include ng-if=\"viewConfig.templateUrl\" src=\"viewConfig.templateUrl\"></ng-include>\n";
// Exports
module.exports = code;